import React from "react";

const AnimatedComponent = () => {
  return (
    <div className="logocontainer">
      <style>
        {`
          @keyframes moveQik {
            0% { transform: translateX(0); }
            50% { transform: translateX(5px); } /* Move slightly right */
            100% { transform: translateX(0); }
          }

          @keyframes moveMarket {
            0% { transform: translateX(0); }
            50% { transform: translateX(-5px); } /* Move slightly left */
            100% { transform: translateX(0); }
          }

          .qik-part {
            color:rgb(42, 46, 48);
            display: inline-block; /* Needed for transform */
            animation: moveQik 5s ease-in-out infinite; /* Adjust timing/iteration as needed */
          }

          .market-part {
            display: inline-block; /* Needed for transform */
            color: orange;
            animation: moveMarket 10s ease-in-out infinite; /* Adjust timing/iteration as needed */
          }

          .logohouse {
             /* Ensures parts stay on the same line */
             white-space: nowrap;
             font-size: 1.5rem; /* Adjust size as needed */
             font-weight: bold;
             /* Add other styling as desired */
          }

          .logocontainer {
              padding: 10px; /* Add padding or other container styles */
              display: inline-block; /* Or adjust display as needed */
          }
        `}
      </style>
      <div className="logohouse">
        <span className="qik-part">QIK</span>{"   "}{"   "}
        <span className="market-part">MARKET 🇿🇦</span>
      </div>
    </div>
  );
};
export default AnimatedComponent;
